<template>
<!--  员工注册-->
  <div class="box" :style="'min-height:' + elHeight + 'px'">
    <back v-if="!showSverlay" @change="$router.push({path: '/register'})"/>
    <div class="user-img">
      <img src="../../assets/login/illustration_staff_MR@2x.png" alt="">
    </div>
    <div class="message">
      <span>请填写注册信息</span>
    </div>
    <div class="form">
      <van-cell-group class="input-box">
        <span class="xingxing">*</span>
        <van-field class="name" v-model="form.username" placeholder="请输入您的姓名" />
      </van-cell-group>
      <van-cell-group class="input-box">
        <span class="xingxing">*</span>
        <van-field class="name" v-model="form.cwid" placeholder="请输入您的CWID" />
      </van-cell-group>
      <van-cell-group :class="classification === '请选择分类' ? 'moren input-box' : 'feimoren input-box'">
        <span class="xingxing">*</span>
        <van-cell is-link :title="classification" @click="show = true" />
        <van-action-sheet cancel-text="取消" close-on-click-action v-model="show" :actions="actions" @select="onSelect" />
      </van-cell-group>
    </div>
    <div class="radio-box">
      <van-radio-group v-model="radio">
        <van-radio name="1">
          <span style="color: #333333;font-weight: 600">本人已阅读并接受</span>
          <span style="color: #0090C5;font-weight: 600" @click="$router.push({path: '/agreement'})">《个人信息披露知情同意》</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <div class="save" @click="save">
      <span>注册</span>
    </div>
<!--    关注二维码-->
    <q-r v-show="showSverlay"/>
  </div>
</template>

<script>
import ActiveIcon from '../../assets/login/icon_select@2x.png'
import InactiveIcon from '../../assets/login/icon_noselect@2x.png'
import Back from "@/components/back/Back";
import QR from "@/views/login/QR";
export default {
  name: "login2",
  components: {QR, Back},
  data() {
    return {
      showSverlay: false,
      elHeight: document.documentElement.clientHeight,
      radio: '',
      activeIcon: ActiveIcon,
      inactiveIcon: InactiveIcon,
      classification: '请选择分类',
      show: false,
      actions: [{ name: '销售' }, { name: '非销售' }],
      form: {
        identity: 2,
        username: '',
        cwid: '',
        openid: localStorage.getItem('openId'),
        unionId: localStorage.getItem('unionId'),
        avatar: localStorage.getItem('userImg-school'),
      }
    }
  },
  methods: {
    save() {
      if (!this.form.username) {
        this.$toast('请填写姓名')
        return
      }
      if (!this.form.cwid) {
        this.$toast('请填写CWID')
        return
      }
      if (this.form.classification === '请选择分类') {
        this.$toast('请选择分类')
        return
      }
      if (!this.radio) {
        this.$toast('请先同意协议')
        return
      }
      let params = {
        ...this.form,
        department: this.classification
      }
      this.$http.post(this.$api.user.regist, params).then(res => {
        let {code, data, message} = res
        if (code === 0) {
          this.$toast('注册成功')
          localStorage.setItem('userId-school', data)
          this.showSverlay = true
        } else {
          this.$toast(message)
        }
      })
    },
    onSelect(item) {
      this.classification = item.name
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.input-box {
  font-size: 24px !important;
  position: relative;
  .xingxing {
    font-size: 26px !important;
    font-weight: bold;
    color: red;
    position: absolute;
    left: -20px;
    top: 20px;
  }
}
::v-deep {
  .van-field__control {
    text-align: center;
  }
  .img-icon {
    width: 38px;
  }
  .moren {
    .van-cell--clickable {
      text-align: center !important;
    }

    .van-cell__title {
      color: #c8c9cc;
    }
  }

  input::-ms-input-placeholder {
    text-align: center;
  }

  input::-webkit-input-placeholder {
    text-align: center;
  }

  .van-cell-group {
    width: 300px;
    height: 40px;
    border-radius: 40px;
    margin-bottom: 40px;
  }

  .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border: none;
  }
}
::v-deep {
  .van-cell {
    background: none;
  }
  .img-icon {
    width: 38px;
  }
  .feimoren {
    .van-cell--clickable {
      text-align: left !important;
    }
  }
  .moren {
    .van-cell--clickable {
      text-align: center !important;
    }
    .van-cell__title {
      color: #c8c9cc;
    }
  }
  input::-ms-input-placeholder{text-align: center;}
  input::-webkit-input-placeholder{text-align: center;}
  .van-cell-group {
    width: 300px;
    height: 40px;
    border-radius: 40px;
    margin-bottom: 40px;
  }
  .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border: none;
  }
}
.save {
  margin: 36px auto;
  font-size: 28px;
  color: #ffffff;
  font-weight: bold;
  line-height: 80px;
  width: 600px;
  height: 80px;
  background: #0090C5;
  border-radius: 40px;
}
.radio-box {
  display: flex;
  justify-content: center;
}
.box {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: #f5f5f5;
  padding-top: 80px;
  .user-img {
    img {
      width: 100%;
    }
  }
  .message {
    margin-bottom: 36px;
    span {
      font-size: 28px;
      color: #0090C5;
      font-weight: 600;
    }
  }
  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
